import { useMocks } from '../../shared/env';
import type { PayrollHistoryImportGateway } from './PayrollHistoryImportGateway';
import { HttpPayrollHistoryImportGateway } from './HttpPayrollHistoryImportGateway';
import { MockPayrollHistoryImportGateway } from './MockPayrollHistoryImportGateway';

export const payrollHistoryImportGateway: PayrollHistoryImportGateway = useMocks
  ? new MockPayrollHistoryImportGateway()
  : new HttpPayrollHistoryImportGateway();
export type { PayrollHistoryImportGateway } from './PayrollHistoryImportGateway';
